<template>
  <div class="container">
    <h1>Session expired</h1>
    <p>
      Please, do <router-link to="/login">login</router-link> again to continue..
    </p>
  </div>
</template>

<script>
  export default {
    created() {
      this.$store.dispatch('logout')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/SessionExpired.vue